import { loginRequest, graphConfig } from "./authConfig";
import { msalInstance } from "../index";

export async function callMsGraph() {
    const account = msalInstance.getActiveAccount();
    if (!account) {
        throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    }

    const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: account
    });

    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(`${graphConfig.graphMeEndpoint}?$select=displayName,jobTitle,mail,businessPhones,officeLocation,department,companyName`, options)
        .then(response => response.json())
        .catch(error => {});
}

export interface GraphUser {
    id: string;
    displayName: string;
    givenName?: string;
    surname?: string;
    mail: string;
    userPrincipalName: string;
    jobTitle?: string;
    department?: string;
    officeLocation?: string;
    accountEnabled: boolean;
}

export async function searchGraphUsers(query: string): Promise<GraphUser[]> {
    if (!query || query.trim().length < 2) {
        return [];
    }

    const account = msalInstance.getActiveAccount();
    if (!account) {
        throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    }

    const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: account,
        scopes: ["User.Read.All"] // Need broader scope for user search
    });

    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;
    headers.append("Authorization", bearer);
    headers.append("ConsistencyLevel", "eventual"); // Required for advanced queries

    const options = {
        method: "GET",
        headers: headers
    };

    // Use $search for better matching - searches displayName and mail fields
    // The search will match first name, last name, or email
    const searchQuery = query.trim();
    const searchUrl = `https://graph.microsoft.com/v1.0/users?$search="displayName:${searchQuery}" OR "mail:${searchQuery}"&$select=id,displayName,givenName,surname,mail,userPrincipalName,jobTitle,department,officeLocation,accountEnabled&$top=20&$count=true`;

    try {
        const fetchResponse = await fetch(searchUrl, options);
        const data = await fetchResponse.json();
        
        // Filter for active users only (client-side filtering since $search and $filter can't be combined easily)
        const activeUsers = (data.value || []).filter((user: GraphUser) => user.accountEnabled === true);
        
        return activeUsers;
    } catch {
        return [];
    }
}